import { useMediaQuery } from '@mui/material';

// TODO - to be removed after the view is rebuilt epic -DEV-7958 / task DEV-8101
const useResponsiveWidth = () => {
  const isSmall = useMediaQuery('(max-width:1450px)');
  const isMedium = useMediaQuery('(min-width:1451px) and (max-width:2000px)');
  const isLarge = useMediaQuery('(min-width:2001px) and (max-width:2200px)');
  const isXLarge = useMediaQuery('(min-width:2201px) and (max-width:2600px)');

  if (isSmall) {
    return '80px';
  }
  if (isMedium) {
    return '100px';
  }
  if (isLarge) {
    return '200px';
  }
  if (isXLarge) {
    return '280px';
  }
  return '300px';
};

export default useResponsiveWidth;
